// @flow
import React from 'react';
import { View, StyleSheet } from 'react-native';
import { withNavigation } from '@react-navigation/compat';
import { Button, Text } from 'trpc-react-native-ui';

import I18n from '../../../lib/i18n';

import type { NavigationRoute, NavigationScreenProp } from '@react-navigation/compat';

const styles = StyleSheet.create({
  button: {
    alignItems: 'center',
    borderWidth: 0,
    height: 40,
    justifyContent: 'center',
  },
  text: {
    color: 'white',
    fontWeight: '600',
    textAlign: 'center',
  },
});

export type StateProps = {
  locale: string,
  theme: string,
};

type ThemeSwitcherProps = {
  navigation: NavigationScreenProp<NavigationRoute>,
  onForceUpdate: Function,
  toggleTheme: Function,
};

const ThemeSwitcher = (props: ThemeSwitcherProps) => (
  <View>
    <Button
      onLongPress={() => {
        props.navigation.navigate('styleGuide');
      }}
      onPress={() => {
        props.toggleTheme();
        props.onForceUpdate && props.onForceUpdate();
      }}
      style={styles.button}
    >
      <Text style={styles.text}>{I18n.t('switchTheme')}</Text>
    </Button>
  </View>
);

export default withNavigation(ThemeSwitcher);
